var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7078 5.50791C14.6281 5.2111 14.4719 4.94042 14.2547 4.72297C14.0375 4.50552 13.767 4.34892 13.4703 4.26885C12.3781 3.9751 8 3.9751 8 3.9751C8 3.9751 3.62187 3.9751 2.52969 4.26729C2.23284 4.3471 1.96223 4.50361 1.74501 4.7211C1.52779 4.93859 1.37162 5.2094 1.29219 5.50635C1 6.6001 1 8.88135 1 8.88135C1 8.88135 1 11.1626 1.29219 12.2548C1.45312 12.8579 1.92812 13.3329 2.52969 13.4938C3.62187 13.7876 8 13.7876 8 13.7876C8 13.7876 12.3781 13.7876 13.4703 13.4938C14.0734 13.3329 14.5469 12.8579 14.7078 12.2548C15 11.1626 15 8.88135 15 8.88135C15 8.88135 15 6.6001 14.7078 5.50791ZM6.60938 10.9751V6.7876L10.2344 8.86572L6.60938 10.9751Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ad79877ccfd0cc7b00227db84412f7a0.svg";
export { ForwardRef as ReactComponent };